export const SET_USING_WINDOW_MOUSE_EVENTS = 'setUsingWindowMouseEvents';
export const SET_PERFORMING_MOUSE_ACTION = 'setPerformingMouseAction';
export const SET_DRAG_IN_PROGRESS = 'setDragInProgress';
export const SET_IS_MOUSE_OVER_STAGE = 'setIsMouseOverStage';
